import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reset-password-success',
  templateUrl: './reset-password-success.component.html',
  styleUrls: ['./reset-password-success.component.scss']
})
export class ResetPasswordSuccessComponent implements OnInit {
  constructor(private readonly router: Router) {}

  ngOnInit() {}

  backToLogin() {
    this.router.navigate(['auth/login']);
  }
}
